@if (incomeTaxEntity$ | async) {
  <form (change)="saveForm()" [formGroup]="kind">
    @if (kinderen.length > 0) {
      <div formArrayName="kinderen">
        @for (item of kinderen.controls; track item; let i = $index) {
          <div [formGroupName]="i" class="row" style="--bs-gutter-x: 0.5rem;">
            <snelstart-ui-text-form-control [label]="i === 0 ? 'Voornaam' : ''"
                                            class="custom-input-250"
                                            formControlName="voornaam"
                                            id="voornaam"
            >
            </snelstart-ui-text-form-control>
            <snelstart-ui-date-form-control [label]="i === 0 ? 'Geboortedatum' : ''"
                                            [required]="isGeboortedatumVeldVerplicht(i)"
                                            class="custom-input-200"
                                            formControlName="geboortedatum"
                                            id="geboortedatum"
                                            placeholder="dd-mm-jjjj"
                                            (blur)="saveForm()"
            >
            </snelstart-ui-date-form-control>

            <snelstart-ui-bsn-form-control [label]="i === 0 ? 'Burgerservicenummer' : ''"
                                           [required]="true"
                                           class="custom-input-200"
                                           formControlName="bsn"
                                           id="bsn"
                                           (blur)="saveForm()"
            >
            </snelstart-ui-bsn-form-control>
            <div class="col-auto">
              <snelstart-ui-button (click)="this.showDialog(i)"
                                   [class]="i === 0 ? 'custom-input-200 pt-3' : 'custom-input-200'"
                                   icon="plus"
                                   type="secondary">Gegevens huishouden
              </snelstart-ui-button>
            </div>

            <snelstart-ui-button (click)="verwijderRij(i)"
                                 [class]="i === 0 ? 'firstrowbutton col-auto' : 'col-auto'"
                                 icon="trash"
                                 iconType="light"
                                 id="buttonDelete"
                                 size="medium"
                                 type="secondary"
            >
            </snelstart-ui-button>
          </div>
        }
      </div>
    }
  </form>

  <snelstart-ui-button (click)="addRij()" class="snelstart-ui-button" icon="plus" id="toevoegKind"
                       type="link">Kind toevoegen
  </snelstart-ui-button>


  <snelstart-ui-dialog-definition [(visible)]="dialogVisible" id="kindBijzonderheden" size="lg"
                                  title="Situatie kind & huishouden">
    <snelstart-ui-dialog-body>
      <form [formGroup]="kind" (change)="saveForm()">
        <div formArrayName="kinderen">
          @for (item of kinderen.controls; track item; let i = $index) {
            <div [formGroupName]="i">
              <div *ngIf="i === this.index">

                <!-- // situatie heel jaar alleenstaand of gewijzigd + niet samen aangifte of samenwonend zonder fiscaal partner-->
                @if (((incomeTaxEntity$ | async)?.aangifte?.aangever?.burgerlijkeStaat === AangeverBurgerlijkeStaat.ALLEENSTAAND) ||
                ((incomeTaxEntity$ | async)?.aangifte?.aangever?.burgerlijkeStaat === AangeverBurgerlijkeStaat.SITUATIE_GEWIJZIGD &&
                  !(incomeTaxEntity$ | async)?.aangifte?.gezamenlijkeAangifte) ||
                ((incomeTaxEntity$ | async)?.aangifte?.aangever?.burgerlijkeStaat === AangeverBurgerlijkeStaat.SAMENWONEND &&
                  (incomeTaxEntity$ | async)?.aangifte?.aangever?.samenwoonSituatie === AangeverSamenwoonSituatie.GEEN)) {
                  <div class="row align-items-center">
                    <div class="col ps-1">
                      <p>Hoorde {{ kinderen.controls[i].get('voornaam')?.value || 'het kind' }}
                        in {{ (incomeTaxEntity$ | async)?.aangifte?.aangifteJaar }} minstens 6 maanden bij
                        het huishouden van <b>aangever</b>?</p>
                    </div>
                    <div class="col-auto ms-auto pe-2">
                      <snelstart-ui-select-form-control
                        (change)="saveForm()"
                        [options]="itemsJaNee"
                        class="custom-input-150"
                        formControlName="ingeschrevenOpAdresAangever"
                        id="ingeschrevenOpAdresAangever-{{i}}"
                      >
                      </snelstart-ui-select-form-control>
                    </div>
                  </div>
                  @if (kinderen.controls[i].get('ingeschrevenOpAdresAangever')?.value === false) {
                    <div class="row align-items-center">
                      <div class="col ps-1 pt-1">
                        <p>Was <b>aangever</b> in {{ (incomeTaxEntity$ | async)?.aangifte?.aangifteJaar }}
                          minstens 6 maanden co-ouder
                          van {{ kinderen.controls[i].get('voornaam')?.value || 'het kind' }}?</p>
                      </div>
                      <div class="col-auto ms-auto pe-2">
                        <snelstart-ui-select-form-control [options]="itemsJaNee"
                                                          class="custom-input-150 col-auto"
                                                          formControlName="coOuderschap"
                                                          id="coOuderschap-{{ i }}"
                        >
                        </snelstart-ui-select-form-control>
                      </div>
                    </div>
                  }
                }

                <!-- // situatie heel jaar gehuwd of samenwonend-->
                @if (((incomeTaxEntity$ | async)?.aangifte?.aangever?.burgerlijkeStaat === AangeverBurgerlijkeStaat.GEHUWD ||
                  (incomeTaxEntity$ | async)?.aangifte?.aangever?.burgerlijkeStaat === AangeverBurgerlijkeStaat.SAMENWONEND) &&
                (incomeTaxEntity$ | async)?.aangifte?.gezamenlijkeAangifte) {
                  <div class="row align-items-center">
                    <div class="col ps-1">
                      <p>Hoorde {{ kinderen.controls[i].get('voornaam')?.value || 'het kind' }}
                        in {{ (incomeTaxEntity$ | async)?.aangifte?.aangifteJaar }} minstens 6 maanden bij
                        het huishouden van <b>aangever en partner</b>?</p>
                    </div>
                    <div class="col-auto ms-auto pe-2">
                      <snelstart-ui-select-form-control [options]="itemsJaNee"
                                                        class="custom-input-150"
                                                        formControlName="ingeschrevenOpAdresAangever"
                                                        id="ingeschrevenOpAdresAangever-{{i}}"
                      >
                      </snelstart-ui-select-form-control>
                    </div>
                  </div>
                  @if (kinderen.controls[i].get('ingeschrevenOpAdresAangever')?.value === false) {
                    <div class="row align-items-center">
                      <div class="col ps-1 pt-1">
                        <p>Was <b>aangever of partner</b>
                          in {{ (incomeTaxEntity$ | async)?.aangifte?.aangifteJaar }}
                          minstens 6 maanden co-ouder
                          van {{ kinderen.controls[i].get('voornaam')?.value || 'het kind' }}?</p>
                      </div>
                      <div class="col-auto ms-auto pe-2">
                        <snelstart-ui-select-form-control
                          [options]="itemsJaNee"
                          class="custom-input-150 col-auto"
                          formControlName="coOuderschap"
                          id="coOuderschap-{{ i }}"
                        >
                        </snelstart-ui-select-form-control>
                      </div>
                    </div>
                  }
                }

                <!-- // situatie gewijzigd & gezamenlijke aangifte-->
                @if ((incomeTaxEntity$ | async)?.aangifte?.aangever?.burgerlijkeStaat === AangeverBurgerlijkeStaat.SITUATIE_GEWIJZIGD &&
                (incomeTaxEntity$ | async)?.aangifte?.gezamenlijkeAangifte) {
                  <div class="row align-items-center">
                    <div class="col ps-1">
                      <p>Hoorde {{ kinderen.controls[i].get('voornaam')?.value || 'het kind' }}
                        in {{ (incomeTaxEntity$ | async)?.aangifte?.aangifteJaar }} minstens 6 maanden bij
                        het huishouden van <b>aangever</b>? <br/>
                        Of was <b>aangever</b>
                        in {{ (incomeTaxEntity$ | async)?.aangifte?.aangifteJaar }} minstens 6 maanden
                        co-ouder van {{ kinderen.controls[i].get('voornaam')?.value || 'het kind' }}
                        ?</p>
                    </div>
                    <div class="col-auto ms-auto pe-2">
                      <snelstart-ui-select-form-control
                        [options]="itemsJaNee"
                        class="custom-input-150"
                        formControlName="ingeschrevenOpAdresAangever"
                        id="ingeschrevenOpAdresAangever-{{i}}"
                      >
                      </snelstart-ui-select-form-control>
                    </div>
                  </div>
                  <div class="row align-items-center">
                    <div class="col ps-1">
                      <p>
                        Hoorde {{ kinderen.controls[i].get('voornaam')?.value || 'het kind' }} {{ (incomeTaxEntity$ | async)?.aangifte?.aangifteJaar }}
                        minstens 6 maanden bij het huishouden van <b>partner</b>? <br/>Of
                        was <b>partner</b> in {{ (incomeTaxEntity$ | async)?.aangifte?.aangifteJaar }}
                        minstens 6 maanden co-ouder
                        van {{ kinderen.controls[i].get('voornaam')?.value || 'het kind' }}?</p>
                    </div>
                    <div class="col-auto ms-auto pe-2">
                      <snelstart-ui-select-form-control
                        [options]="itemsJaNee"
                        class="custom-input-150 col-auto"
                        formControlName="ingeschrevenOpAdresPartner"
                        id="ingeschrevenOpAdresAangever-{{i}}"
                      >
                      </snelstart-ui-select-form-control>
                    </div>
                  </div>
                }
              </div>
            </div>
          }
        </div>
      </form>
    </snelstart-ui-dialog-body>
    <snelstart-ui-dialog-buttons>
      <snelstart-ui-button btn-x class="me-1" id="cancel" type="secondary">Annuleren
      </snelstart-ui-button>
      <snelstart-ui-button btn-x icon="check" id="save" type="primary">Opslaan</snelstart-ui-button>
    </snelstart-ui-dialog-buttons>
  </snelstart-ui-dialog-definition>
}
